// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// fixing IE
require('es6-promise/auto')

import Vue from 'vue'
import App from './App'
import VueTouch from 'vue-touch'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueLocalStorage from 'vue-localstorage'
import Application from './components/Application.vue'
import Applications from './components/Applications.vue'
import PlannedDay from './components/PlannedDay.vue'
import PresencePanel from './components/PresencePanel.vue'
import PresenceEntry from './components/PresenceEntry.vue'
import PresenceList from './components/PresenceList.vue'
import EmployeesList from './components/EmployeesList.vue'
import Shifts from './components/Shifts.vue'
import Shift from './components/Shift.vue'
import Vacations from './components/Vacations.vue'
import Vacation from './components/Vacation.vue'
import VueSuperagent from 'vue-superagent'
import Moment from 'vue-moment'
import 'moment/locale/de'
import VueBlu from 'vue-blu'
import 'vue-blu/dist/css/vue-blu.min.css'
import Spinner from 'vue-simple-spinner'
import store from './store'

Vue.config.productionTip = false
Vue.component('spinner', Spinner)
Vue.component('icon', Icon)
Vue.component('application', Application)
Vue.component('applications', Applications)
Vue.component('shift', Shift)
Vue.component('shifts', Shifts)
Vue.component('vacations', Vacations)
Vue.component('vacation', Vacation)
Vue.component('planned-day', PlannedDay)
Vue.component('employees-list', EmployeesList)
Vue.component('presence-panel', PresencePanel)
Vue.component('presence-entry', PresenceEntry)
Vue.component('presence-list', PresenceList)

Vue.use(VueTouch)
Vue.use(VueBlu)
Vue.use(Moment)

let host = window.location.hostname
if (host === 'schichtplan.pepperz.de') {
  host = 'salat.pepperz.de'
}
if (host === 'schichtplan.yaamxso36.de') {
  host = 'salat.yaamxso36.de'
}
if (host === 'schichtplantest.pepperz.de') {
  host = 'salatverkostung.pepperz.de'
}

let apiUrl = window.location.protocol + '//' + host
if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.')) {
  apiUrl += ':8000'
}
let apiHost = apiUrl
apiUrl += '/api'
Vue.use(VueSuperagent, {
  baseUrl: apiUrl
})
Vue.use(VueLocalStorage)

Vue.filter('starttime', function (value) {
  let vals = value.split(':')
  return vals[0] + ':' + vals[1] + ' Uhr'
})
Vue.filter('linebreaks', function (text) {
  return text.replace(/\n/g, '<br/>')
})

if (!Date.prototype.toISODate) {
  // eslint-disable-next-line no-extend-native
  Date.prototype.toISODate = function () {
    return this.getFullYear() + '-' +
      ('0' + (this.getMonth() + 1)).slice(-2) + '-' +
      ('0' + this.getDate()).slice(-2)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  localStorage: {
    loginToken: {
      type: String
    }
  },
  template: '<App ref="app"/>',
  components: { App },
  methods: {
    getLoginToken: function () {
      if (this.$refs['app']) {
        return this.$refs.app.loginToken
      } else {
        return 'undefined'
      }
    }
  },
  store,
  data: {
    apiHost
  }
})



// WEBPACK FOOTER //
// ./src/main.js